/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
//import usePrevious from "utils/hooks/usePrevious";

//const MAX_STUDENTS_FOR_OVERFLOWING = 5;
const useStudentList = ({
	updateActivityPopup,
	reservation
}) => {
    const [studentList, setStudentList] = useState([]);
    //const prevStudentList = usePrevious(studentList);
	useEffect(() => {
        fillStudentList();
    }, []);
	useEffect(() => {
        updateActivityPopup.adjustPopupPosition();
        //if (studentList.length > MAX_STUDENTS_FOR_OVERFLOWING || prevStudentList?.length === studentList.length)
        //    return;
    }, [studentList]);
	function fillStudentList() {
        const { responsible, others } = reservation.students;
        setStudentList([
            responsible,
            ...others
        ]);
    }
	function maxCapacityHasBeenReached() {
        return studentList.length === Number(reservation.space.maxCapacity);
    }
    function addStudent(newStudent) {
        setStudentList([...studentList, {
            ...newStudent,
            saved: false
        }]);
    }
    function getStudentsNotSaved() {
        return studentList.filter(({ saved }) => !saved);
    }
    function existStudentsForTakeAttendance() {
		return studentList.some(({ forTakeAttendance }) => forTakeAttendance);
	}
    function existStudentsNotSaved() {
		return studentList.some(({ saved }) => !saved);
	}
	return {
		value: studentList,
        update: setStudentList,
		maxCapacityHasBeenReached,
        add: addStudent,
        getStudentsNotSaved,
        existStudentsForTakeAttendance,
        existStudentsNotSaved
	};
}	
	
export default useStudentList;